import React, { useContext, useState, forwardRef } from 'react';
import cn from 'clsx';
import { string, bool, func, shape, any } from 'prop-types';
import FormContext from '../../context/FormContext.js';
import FormGroupContext from '../../context/FormGroupContext.js';

/**
 * FormSwitch component.
 */
const FormSwitch = /*#__PURE__*/forwardRef(({
  className,
  name,
  rounded,
  onChange,
  onClick,
  on,
  off,
  fullWidth,
  transparent,
  defaultValue
}, ref) => {
  const {
    inputId
  } = useContext(FormGroupContext);
  const {
    inverted,
    onChange: onFormChange,
    defaultValues
  } = useContext(FormContext);
  const [checkedValue, setCheckedValue] = useState(defaultValue || (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues[name]) || on.value);

  /**
   * Update the checked value before calling any given onChange handler.
   */
  const handleChange = evt => {
    const {
      checked,
      value
    } = evt.target;
    if (checked) {
      setCheckedValue(value);
    }
    if (onChange) {
      onChange(evt);
    }
    if (onFormChange) {
      onFormChange(evt);
    }
  };
  return /*#__PURE__*/React.createElement("fieldset", {
    className: cn("form-switch d-flex p-relative", className, rounded && 'form-switch--rounded', inverted && 'form-switch--inverted', fullWidth && 'form-switch--full-width', transparent && 'form-switch--transparent'),
    ref: ref,
    onChange: handleChange
  }, /*#__PURE__*/React.createElement("legend", {
    className: "sr-only"
  }, name), /*#__PURE__*/React.createElement("input", {
    className: "form-switch__input p-absolute",
    type: "radio",
    name: name,
    id: `${inputId}-on`,
    value: on.value,
    onClick: onClick,
    defaultChecked: checkedValue === on.value
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-switch__label p-relative flex-grow-1 text-center pa-sm ma-reset",
    htmlFor: `${inputId}-on`,
    id: `label-${inputId}-on`
  }, on.text), /*#__PURE__*/React.createElement("input", {
    className: "form-switch__input p-absolute",
    type: "radio",
    name: name,
    id: `${inputId}-off`,
    value: off.value,
    onClick: onClick,
    defaultChecked: checkedValue === off.value
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-switch__label p-relative flex-grow-1 text-center pa-sm ma-reset",
    htmlFor: `${inputId}-off`,
    id: `label-${inputId}-off`
  }, off.text), /*#__PURE__*/React.createElement("span", {
    className: cn("form-switch__selector full-height p-absolute", className, rounded && 'form-switch__selector--rounded')
  }));
});
FormSwitch.displayName = 'FormSwitch';
FormSwitch.defaultProps = {
  className: null,
  rounded: true,
  onChange: null,
  onClick: null,
  fullWidth: false,
  transparent: false,
  defaultValue: null
};
FormSwitch.propTypes = process.env.NODE_ENV !== "production" ? {
  defaultValue: any,
  className: string,
  name: string.isRequired,
  rounded: bool,
  onChange: func,
  onClick: func,
  fullWidth: bool,
  transparent: bool,
  on: shape({
    text: string,
    value: string
  }).isRequired,
  off: shape({
    text: string,
    value: string
  }).isRequired
} : {};
export default FormSwitch;